
import Vue from "vue";
import { ViewColumn } from "@/utils/views/view-column";

export default Vue.extend({
	props: {
		value: {
			type: Object as ()=>ViewColumn,
			required: true
		}
	},
	computed: {
		openInNewTab():boolean {
			if (!this.value.ClickActionOptions) return false;
			return this.value.ClickActionOptions.openInNewTab || false;
		}
	},
	methods: {
		setOpenInNewTab(value:boolean){
			if (!this.value.ClickActionOptions) {
				this.value.ClickActionOptions = {};
			}
			this.value.ClickActionOptions.openInNewTab = value;
		}
	},
	i18nEx: {
		componentPrefix: "components.view-editor"
	}
});
